import React from 'react';
import SignInModal from '../components/SignInModal';

export default function LoginPage() {
  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4">
      <SignInModal mode="page" />
    </div>
  );
}
